import { useRef } from 'react';
import { Camera, Upload } from 'lucide-react';
import { Button } from './ui/button';

export default function CameraFileInput({
  accept = 'image/*',
  disabled = false,
  multiple = false,
  onFilesSelected,
  onFileSelected,
  fileLabel = 'Selecionar arquivo',
  cameraLabel = 'Tirar foto',
  className = '',
  'data-testid': dataTestId
}) {
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  const handleFiles = (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = '';
    if (files.length === 0) return;
    if (onFilesSelected) {
      onFilesSelected(files);
      return;
    }
    onFileSelected?.(files[0]);
  };

  return (
    <div className={`flex flex-col gap-2 sm:flex-row sm:flex-wrap ${className}`}>
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={handleFiles}
        data-testid={dataTestId}
      />
      <input
        ref={cameraInputRef}
        type="file"
        className="hidden"
        accept="image/*"
        capture="environment"
        disabled={disabled}
        onChange={handleFiles}
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => fileInputRef.current?.click()}
      >
        <Upload className="h-4 w-4" />
        {fileLabel}
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => cameraInputRef.current?.click()}
      >
        <Camera className="h-4 w-4" />
        {cameraLabel}
      </Button>
    </div>
  );
}
